// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"l5-z","colorTextValue":"m5-z","swatches":"n5-z","collapseLink":"o5-z","isCollapsed":"p5-z","dropdown":"q5-z","disabled":"r5-z"};